import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { applyJobv2, fetchPublicJob } from '../../actions/jobs';
import PreScreening from './preScreeningQuestions/preScreeningQuestions';
import FinishForm from './finishForm/finishForm';
import ErrorForm from './ErrorWindow/ErrorForm';
import UserDetail from './userDetail/userDetail';
import ReviewForm from './reviewForm/reviewForm';
import { userExistConfig } from '../../utils/constants';
import { setNotification } from '../../actions/appNotifications';
import UploadCV from './uploadCv/uploadCv';
import { validateUser } from '../../actions/user';
import { QUICK_APPLY_USER } from './types';

function QuickApply() {
  const [step, setStep] = useState(1);
  const { id } = useParams();
  const [data, setData] = useState({
    JobId: localStorage.getItem('OpenedJobId') ? JSON.parse(localStorage.getItem('OpenedJobId')) : id || '',
    UserId: Number(localStorage.getItem('UserId')),
    PhoneCountryCode: '',
    Phone: '',
    IsManageConcent: false,
    Cv: undefined
  });
  const [error, setError] = useState(null);
  const [questions, setQuestions] = useState({});
  const [userDataExist, setUserDataExist] = useState(false);
  const [userExist, setUserExist] = useState(null);

  const job = useSelector((state) => state.job.response);
  const userValidation = useSelector((state) => state.user?.profile?.validation?.Data);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const questionAvailability = Object.values(questions).every((x) => x === null || x?.trim() === '');

  const close = () => navigate(window.location.pathname);

  const setConsentChecked = (consentCheck) => {
    setData((prevState) => ({
      ...prevState,
      IsManageConcent: consentCheck
    }));
  };

  const handleAnswers = (ans) => {
    switch (ans) {
      case 1:
        if (data?.Question1) return data?.Answer1 ? 'true' : 'false';
        return null;
      case 2:
        if (data?.Question2) return data?.Answer2 ? 'true' : 'false';
        return null;
      case 3:
        if (data?.Question3) return data?.Answer3 ? 'true' : 'false';
        return null;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (userValidation === 'User is already exist') {
      setUserExist('userExists');
    } else if (userValidation === 'You have already applied for a Job') {
      setUserExist('applied');
    } else {
      setUserExist(null);
    }
  }, [userValidation]);

  useEffect(() => {
    if (job && job.Id === data.JobId) {
      setQuestions({
        Question1: job.Question1,
        Question2: job.Question2,
        Question3: job.Question3
      });
    }
  }, [job, data]);

  useEffect(() => {
    if (data?.JobId) dispatch(fetchPublicJob(data?.JobId));
  }, [data?.JobId]);

  const handleNavigattion = (type) => {
    switch (type) {
      case 'contact':
        setStep(1);
        break;
      case 'attachment':
        setStep(2);
        break;
      case 'answers':
        setStep(3);
        break;
      default:
        setStep(1);
    }
  };

  switch (step) {
    case 1:
      return (
        <UserDetail
          step={step}
          totalStep={5}
          nextHandle={(newData) => {
            dispatch(validateUser(data?.JobId, newData?.email))
              .then((response) => {
                if (response?.value?.Message === QUICK_APPLY_USER.EXIST) {
                  dispatch(setNotification(userExistConfig.CREATE_SUCCESS()));
                } else if (response?.value?.Message === QUICK_APPLY_USER.ALREADY_APPLIED) {
                  dispatch(setNotification(userExistConfig.JOB_ALREADY_APPLIED()));
                } else {
                  setStep(2);
                  setData((prevState) => ({
                    ...prevState,
                    ...newData
                  }));
                }
              })
              .catch((err) => {
                dispatch(setNotification(userExistConfig.SERVER_ERROR));
                setStep(1);
                setData((prevState) => ({
                  ...prevState,
                  ...newData
                }));
                throw err;
              });
          }}
          cancel={() => {
            setStep(1);
            close();
          }}
          data={data}
          questions={questions}
          userDataExist={userDataExist}
          jobTitle={job?.JobTitle}
        />
      );
    case 2:
      return (
        <UploadCV
          step={step}
          totalStep={5}
          nextHandle={(newData) => {
            if (questionAvailability) {
              setStep(4);
            } else {
              setStep(3);
            }
            setData((prevState) => ({
              ...prevState,
              ...newData
            }));
          }}
          cancel={() => {
            setStep(2);
            close();
          }}
          back={() => {
            setStep(1);
          }}
          data={data}
          questions={questions}
          userDataExist={userDataExist}
          jobTitle={job?.JobTitle}
        />
      );
    case 3:
      return (
        <PreScreening
          step={step}
          totalStep={5}
          data={data}
          nextHandle={(newData) => {
            setStep(4);
            setData((prevState) => ({
              ...prevState,
              ...newData,
              ...questions
            }));
          }}
          backHandle={() => setStep(2)}
          cancel={() => {
            setStep(1);
            close();
          }}
          questions={questions}
          jobTitle={job?.JobTitle}
        />
      );
    case 4:
      return (
        <ReviewForm
          step={step}
          questionAvailable={questionAvailability}
          totalStep={5}
          navigate={(type) => handleNavigattion(type)}
          nextHandle={async (newData) => {
            setData((prevState) => ({
              ...prevState,
              ...newData
            }));
            dispatch(
              applyJobv2({
                Email: data.email,
                FirstName: data.firstName,
                LastName: data.lastName,
                PhoneCountryCode: data.PhoneCountryCode,
                Country: data.countryName,
                IsManageConcent: data.IsManageConcent,
                JobId: data.JobId,
                Phone: data.Phone,
                Answer1: handleAnswers(1),
                Answer2: handleAnswers(2),
                Answer3: handleAnswers(3),
                Cv: data?.Cv
              })
            );
            setStep(5);
          }}
          cancel={() => {
            setStep(1);
            close();
          }}
          back={() => {
            if (questionAvailability) {
              setStep(2);
            } else {
              setStep(3);
            }
          }}
          data={data}
          questions={questions}
          userDataExist={userDataExist}
          jobTitle={job?.JobTitle}
          setConsentChecked={setConsentChecked}
        />
      );
    case 5:
      return (
        <FinishForm
          data={data}
          step={step}
          totalStep={5}
          cancel={() => {
            setStep(1);
            close();
          }}
        />
      );
    case 'error':
      return <ErrorForm error={error} cancel={close} backHandle={() => setStep(1)} />;
    default:
      return null;
  }
}
export default QuickApply;
